import { Check } from "lucide-react";

const reasons = [
  "Certified & experienced technicians",
  "Clean, labeled structured cabling",
  "24/7 monitoring & rapid response",
  "Transparent, upfront pricing",
];

export const About = () => {
  return (
    <section id="about" className="py-24 sm:py-32">
      <div className="container mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 relative">
            <div className="border border-slate-200">
              <img
                src="https://images.unsplash.com/photo-1581092919535-7146ff1a590b"
                alt="IT technician working on a server rack"
                className="w-full h-[420px] lg:h-[500px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-8 hidden sm:block">
              <div className="font-heading font-black text-4xl">ZID</div>
              <div className="text-sm text-blue-100 mt-1">IT Solutions</div>
            </div>
          </div>

          <div className="lg:col-span-6 lg:pl-8">
            <span className="text-sm font-semibold uppercase tracking-widest text-blue-600">Why Choose Us</span>
            <h2 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter text-slate-950 mt-4">
              Reliable technology, done properly
            </h2>
            <p className="text-lg text-slate-600 mt-5 leading-relaxed">
              We treat your infrastructure like our own. Every install is engineered for
              performance, documented for clarity, and backed by dependable support.
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mt-8">
              {reasons.map((r, i) => (
                <div key={i} data-testid={`reason-${i}`} className="flex items-start gap-3">
                  <div className="h-6 w-6 flex-shrink-0 bg-blue-600 flex items-center justify-center mt-0.5">
                    <Check size={15} className="text-white" />
                  </div>
                  <span className="text-slate-700 font-medium">{r}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
